<template>
	<div v-show="infoData.length || totalData.length" class="info-card flex">
		<div v-if="infoData.length" class="item flex-grow">
			<ul>
				<li v-for="(item, i) in infoData" :key="i" class="flex">
					<label>{{item.name}}：</label>
					<p class="flex-grow">{{item.value}}</p>
				</li>
			</ul>
		</div>
		<div v-for="(item, i) in totalData" :key="i" class="item total flex-column flex-center flex-grow">
			<div :style="{'color': item.color ? `var(--color-${item.color})` : '#000'}">{{item.value}}</div>
			<p>{{item.name}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'infoCard',
		
		props: {
			code: String,
			id: [String, Number, Boolean],
			info: Array,
			total: Array
		},

		data() {
			return {
				asyncInfo: [],
				asyncTotal: []
			}
		},

		computed: {
			infoData() {
				return this.info || this.asyncInfo;
			},

			totalData() {
				return this.total || this.asyncTotal;
			}
		},

		watch: {
			id: {
				handler(val) {
					if (!this.code || !val) {
						this.asyncInfo = [];
						this.asyncTotal = [];
						return;
					}
					
					switch (this.code) {
					case 'assetsReceiveOrder':
						this.request({
							url: '/asset_receive_apply/detail',
							data: {
								id: val
							},
							success: data => {
								this.asyncInfo = [{
									name: '申请人',
									value: data.apply_user_name
								}, {
									name: '申请时间',
									value: data.create_date
								}];

								let count = 0;
								data.item_list.forEach(item => {
									count += parseInt(item.receive_quantity);
								});
								this.asyncTotal = [{
									name: '领用数量',
									value: count
								}];
							}
						});
						break;

					default:
						this.request({
							url: '/system/cardInfo',
							data: {
								card_code: this.code,
								id: this.id
							},
							success: data => {
								this.asyncInfo = data.info || [];
								this.asyncTotal = data.total || [];
							}
						});
					}
				},
				immediate: true
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.info-card  {
		gap: .14rem;

		&:nth-child(2) {
			margin-top: .14rem;
		}

		.item {
			flex-grow: 2.6;
			background: #FAFAFA;

			&.total {
				flex-grow: 1;
				min-height: 1.2rem;

				div {
					font-size: .32rem;
					font-weight: bold;
				}

				p {
					margin-top: .16rem;
					font-size: .24rem;
					color: #999;
				}
			}

			ul {
				padding: .12rem .24rem;

				li {
					padding: .04rem 0;
					line-height: .32rem;
					font-size: .24rem;
					color: #999;
				}
			}
		}
	}
</style>
